import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectMortgageAvailableFilter } from 'shared/selectors/advancedFilters';

export const MortgageAvailableContainer: FC = () => {
  const { label, value } = useSelector(selectMortgageAvailableFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setMortgageAvailable', arguments: [newValue || null] });
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Checkbox label={label} checked={value} onChange={handleChange} />
    </InlineFilter>
  );
};
